import React, { useState } from "react";
import WhatsAppMessage from "../WhatsAppMessage";
import { Box } from "@mui/material";
import CustomTabs from "../../common/custom-tabs";
import MarketingLogs from "../MarketingLogs/MarketingLogs";
import FileUploadLogs from "../FileUploadLogs/FileUploadLogs";
import RCSBroadcastLogs from "./../Rcs_logs/RCSBroadcastLogsTable.js";
import RcsChatLog from "../RCSChatlogs/RcsChatLog.js";
import VoiceLogs from "../VoiceLogs/VoiceLogs";

const LogsDashboard = (props) => {
  // 🟢 1. Fetch permissions to determine the environment
  const permissionsFromStorage = JSON.parse(localStorage.getItem("permissions") || "[]");
  const hasRcsBotCreate = permissionsFromStorage.includes("rcs_bot_create.view");
  // conversations.view is granted only by WhatsApp addons, so it marks the WA channel
  const hasWa = permissionsFromStorage.includes("conversations.view");
  // Same app flag that gates the sidebar's Voice Calls section
  const hasVoice = JSON.parse(localStorage.getItem("apps") || "[]").includes("voice");

  // 🟢 2. SMART DEFAULT: Default to RCS Logs (3) if RCS user, otherwise Chat Logs (0)
  const initialTab = hasWa ? 0 : hasRcsBotCreate ? 3 : 2;
  const [currentTab, setCurrentTab] = useState(initialTab);

  // 🟢 3. Mutually Exclusive Tabs Layout
  const allTabs = [
    { label: "Chat Logs", value: 0, show: hasWa },         // WhatsApp
    { label: "Broadcast Logs", value: 1, show: hasWa },    // WhatsApp
    { label: "RCS Logs", value: 3, show: hasRcsBotCreate },           // RCS
    { label: "RCS Chat Logs", value: 4, show: hasRcsBotCreate },      // RCS
    { label: "File Upload Logs", value: 2, show: true },              // Always visible
    { label: "Voice Logs", value: 5, show: hasVoice },                // Voice, always last
  ];

  // Filter out the hidden tabs
  const tabs = allTabs.filter(tab => tab.show !== false);

  const handleTabsChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          pt: 5,
          px: 3,
          backgroundColor: "#F7F7F7",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <CustomTabs
            value={currentTab}
            onChange={handleTabsChange}
            tabs={tabs}
            inactiveBgColor="#E8EAED"
            backgroundColor="#E8EAED"
          />
        </Box>
        
        {/* Render logic remains tied to the exact values */}
        {currentTab === 0 && <WhatsAppMessage props={props} />}
        {currentTab === 1 && <MarketingLogs props={props} />}
        {currentTab === 2 && <FileUploadLogs props={props} />}
        {currentTab === 3 && <RCSBroadcastLogs props={props} />}
        {currentTab === 4 && <RcsChatLog props={props} />}
        {currentTab === 5 && <VoiceLogs props={props} />}
      </Box>
    </div>
  );
};

export default LogsDashboard;